import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/SoldOut.css';
import '../styles/Home.css';
import WhatsappCTA from '../components/WhatsappCTA';

const translations = {
  en: {
    title: "Personalized Tour",
    h2_1: "Discover Your Perfect Escape—Schedule a Personalized Tour Today!",
    p1: "Picture yourself walking the land where your future could come to life—surrounded by natural beauty, breathing in fresh coastal air, and envisioning a lifestyle where every day feels like an adventure. We don’t just sell lots; we invite you to experience the magic of this region firsthand with a personalized tour crafted around your vision.",
    h2_2: "Why take a tour?",
    bullet1: "📍 Explore available lots with our local experts, who’ll guide you to prime locations for building, privacy, or breathtaking views.",
    bullet2: "📍 Uncover hidden gems—from serene waterways and lush trails to secluded beaches where nature takes center stage.",
    bullet3: "📍 Connect with the area’s culture: Discover vibrant local markets, charming villages, and spots where community and tradition thrive.",
    h2_3: "What you’ll experience: ",
    experience1: "🌊 Natural wonders: Glimmering waterways, biodiverse ecosystems, and untouched landscapes perfect for outdoor adventures.",
    experience2: "🌴 Community hotspots: Areas where future neighborhoods are taking shape, blending modern comfort with respect for nature.",
    experience3: "🍃 Cultural touchpoints: Taste local flavors, meet artisans, and soak in the rhythms of daily life in this vibrant region.",
    h2_4: "Book now",
    button: "Book"
  },
  es: {
    title: "Tour Personalizado",
    h2_1: "Descubre tu Escape Perfecto—¡Agenda un Tour Personalizado Hoy!",
    p1: "Imagínate caminando por la tierra donde tu futuro podría tomar forma—rodeado de belleza natural, respirando aire costero fresco y visualizando un estilo de vida donde cada día se siente como una aventura. No solo vendemos lotes; te invitamos a experimentar la magia de esta región de primera mano con un tour personalizado diseñado alrededor de tu visión.",
    h2_2: "¿Por qué hacer un tour?",
    bullet1: "📍 Explora lotes disponibles con nuestros expertos locales, quienes te guiarán a ubicaciones privilegiadas para construcción, privacidad o vistas impresionantes.",
    bullet2: "📍 Descubre joyas ocultas—desde serenos cuerpos de agua y senderos frondosos hasta playas vírgenes donde la naturaleza es protagonista.",
    bullet3: "📍 Conéctate con la cultura local: Descubre mercados vibrantes, pueblos encantadores y lugares donde comunidad y tradición florecen.",
    h2_3: "Lo que experimentarás:",
    experience1: "🌊 Maravillas naturales: Cuerpos de agua relucientes, ecosistemas biodiversos y paisajes vírgenes perfectos para aventuras al aire libre.",
    experience2: "🌴 Puntos clave comunitarios: Áreas donde futuros vecindarios están tomando forma, combinando comodidad moderna con respeto por la naturaleza.",
    experience3: "🍃 Puntos culturales: Prueba sabores locales, conoce artesanos y absorbe los ritmos de la vida diaria en esta vibrante región.",
    h2_4: "Reserva ahora",
    button: "Reservar"
  }
};

const Tour = ({ language }) => {
  return (
    <div className="testimonial">
      <div className="testimonial-text">
        <h1>{translations[language].title}</h1>
        
        <h2>{translations[language].h2_1}</h2>
        <p>{translations[language].p1}</p>

        <h2>{translations[language].h2_2}</h2>
        <div className="callout-box">
          <p>{translations[language].bullet1}</p>
          <p>{translations[language].bullet2}</p>
          <p>{translations[language].bullet3}</p>
        </div>

        <h2>{translations[language].h2_3}</h2>
        <p>{translations[language].experience1}</p>
        <p>{translations[language].experience2}</p>
        <p>{translations[language].experience3}</p>

        <WhatsappCTA language={language}/>

        <h2>{translations[language].h2_4}</h2>
        <Link to="/contact" className="cta-button">
          {translations[language].button}
        </Link>
      </div>
    </div>
  );
};

export default Tour;